var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderBack',{attrs:{"title":_vm.$t('个人资料')}}),_c('PersonalContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }